import { createAsyncThunk } from "@reduxjs/toolkit";
import { ConnectPartnerSocket } from "../../domain/usecases/ConnectPartnerSocket";
import { DisconnectPartnerSocket } from "../../domain/usecases/DisconnectPartnerSocket";
import { SendInvitationPartner, SendInvitationPartnerParams } from "../../domain/usecases/sendInvitationPartner";
import { ResponseInvitation, ResponseInvitationParams } from "../../domain/usecases/responseInvitation";
import { GetPendingPartners } from "../../domain/usecases/getPendingPartners";
import { DeleteCurrentPartner, DeleteCurrentPartnerParams } from "../../domain/usecases/deleteCurrentPartner";
import { GetNotificationsPartner } from "../../domain/usecases/getNotificationsPartner";
import { PartnerPending } from "../../domain/entities/partnerPending";
import { GetNotificationsPartnerResponse } from "../../domain/usecases/getNotificationsPartnerResponse";
import { CancelInvitationPartner, CancelInvitationPartnerParams } from "../../domain/usecases/CancelInvitationPartner";
import { deleteAllPartnerFromList, deletePartnerFromList, newPartnerReceived, newPartnerResponse, setErrorPartnerResponse } from "./PartnerSlice";
import { deletePartner, setPartner } from "../../../profile/presentation/store/OnboardingSlice";
import { notificationReceived } from "../../../match/presentation/store/MatchSlice";
import { RootState } from "../../../../core/store/store";

export const onConnectPartnerSocket = createAsyncThunk(
	"partner/connect-socket",
	async (_, { extra, dispatch }) => {
		const { connectPartnerSocket } = extra as {
			connectPartnerSocket: ConnectPartnerSocket;
		};
		await connectPartnerSocket.execute();
		const socket = connectPartnerSocket.getSocket();
		if (!socket) return; 
		socket.on("error", (error: any) => {
			if (error === "ERROR_CREATING_PARTNER_RESPONSE" || error === "Error! You cannot invite the user") dispatch(setErrorPartnerResponse(error));
			console.error("Error en el socket:", error);
		});
		return;
	}
);

export const onDisconnectPartnerSocket = createAsyncThunk(
	"partner/disconnect-socket",
	async (_, { extra }) => {
		const { disconnectPartnerSocket } = extra as {
			disconnectPartnerSocket: DisconnectPartnerSocket;
		};
		await disconnectPartnerSocket.execute();
		return;
	}
);

export const onGetPendingPartner = createAsyncThunk(
	"partner/getPartner",
	async (_,{extra}) =>{
		const {getPendingPartners} = extra as {
			getPendingPartners: GetPendingPartners;
		};
		const result = await getPendingPartners.execute();
		return result;
	}
);


export const onDeleteCurrentPartner = createAsyncThunk(
	"/profile/partner-delete",
	async (params: DeleteCurrentPartnerParams, { extra }) => {
		const { deleteCurrentPartner } = extra as { deleteCurrentPartner: DeleteCurrentPartner; };
		const result = await deleteCurrentPartner.execute(params);
		return result;
	}
);


export const onCancelCurrentInvitation = createAsyncThunk(
	"/profile/partner-cancel",
	async (params: CancelInvitationPartnerParams, { extra }) => {
		const { cancelPartner } = extra as { cancelPartner: CancelInvitationPartner; };
		const result = await cancelPartner.execute(params);
		return result;
	}
);


export const onSendInvitation = createAsyncThunk(
	"partner/partner",
	async (params: SendInvitationPartnerParams, { extra, dispatch }) => {
		const { emitPartnerRequest } = extra as {
			emitPartnerRequest: SendInvitationPartner;
		};
		await emitPartnerRequest.execute(params);
		return ;
	}
);

export const onResponseInvitation = createAsyncThunk(
	"partner/partner-response",
	async (params: ResponseInvitationParams, { extra }) => {
		const { onEmitPartnerResponse } = extra as {
			onEmitPartnerResponse: ResponseInvitation;
		};
		await onEmitPartnerResponse.execute(params);
		return;
	}
);


export const onListenNotification = createAsyncThunk(
    "partner/notification_partner",
    async (_, { extra, getState, dispatch }) => {
        const { getNotificationsPartner } = extra as {
            getNotificationsPartner: GetNotificationsPartner;
        };

        getNotificationsPartner.execute((partner: PartnerPending) => {
            const state = getState() as RootState;
            const partnerExists = state.partner.partners.some(
                p => p.user_id === partner.user_id
            );
			const userPartner = state.onboarding.partner;
			const configPartner = state.onboarding.profileConfig;
			if (userPartner && (userPartner.user_id === partner.user_id || userPartner.user_id1 === partner.user_id)) {
				dispatch(deletePartner());
			} else if (configPartner && configPartner.partner?.id === partner.user_id) {
				dispatch(deletePartner());
			}
            if (!partnerExists) {
                dispatch(newPartnerReceived(partner));
                dispatch(notificationReceived({
					title: "New Partner Invitation",
					subtitle: `You have received an invitation from ${partner.username} to become partners`,
					data: { type: "partner" }
				}));
            }
        });
    }
);

export const onListenNotificationResponse = createAsyncThunk(
	"partner/notification_partner_response",
	async (_, { extra,dispatch }) => {
		const { getNotificationsPartnerResponse } = extra as {
			getNotificationsPartnerResponse: GetNotificationsPartnerResponse;
		};
		getNotificationsPartnerResponse.execute((data:any)=>{
			if (data.status === "rejected") {
				dispatch(deletePartnerFromList(data))
				dispatch(deletePartner())
				dispatch(notificationReceived({
					title: "Invitation Canceled",
					subtitle: `Your invitation has been canceled from ${data.username || 'a partner'} to become partners`,
					data: { type: "partner" }
				}));
			}else if (data.status === "accepted") {
				dispatch(newPartnerResponse(data))
				dispatch(setPartner(data))
				dispatch(deleteAllPartnerFromList());
				dispatch(notificationReceived({
					title: "Invitation Accepted",
					subtitle: `Your invitation has been accepted from ${data.username || 'a partner'} to become partners`,
					data: { type: "partner" }
				}));
			}
		});
	}
);

